import Api from '@/services/Api'

export default {
  // Stanje skladista i promet po artiklima - one row per article.
  stock (query) {
    return Api().get('warehousestock', {
      params: query
    })
  },
  // Kartica jednog artikla - every movement over the period.
  card (query) {
    return Api().get('warehousestock/card', {
      params: query
    })
  }
}
